export default function ListIcon(props) {
  return (
    <svg width={18} height={18} viewBox="0 0 18 18" {...props}>
      <path fill="#666" d="M3 16.5H0v-3h3v3Zm0-9H0v3h3v-3Zm0-6H0v3h3v-3Zm2.25 0v3H18v-3H5.25Zm0 9H18v-3H5.25v3Zm0 6H18v-3H5.25v3Z" />
    </svg>
  );
}
